import React, { ReactElement } from 'react';

interface Props {
  condition: boolean;
  children: ReactElement;
  fallback?: ReactElement;
}

const RenderIf: React.FC<Props> = props => {
  const { condition, children, fallback } = props;

  if (condition) return children;
  return fallback ?? null;
};

export default RenderIf;
